import styled from 'styled-components';

export const TelefoneContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    @media (max-width: 290px) {
        flex-direction: column;
    }
`;

export const TelefoneEscondidoContainer = styled.div`
    position: relative;
`;

export const WhatsappButtonContainer = styled.div`
    grid-column: ${(props) => (props.length === 4 ? 'unset' : '2')};
`;

export const TelefoneEscondidoTexto = styled.h2`
    width: 100%;
    white-space: nowrap;
    cursor: ${(props) => (props.isMaskEnabled ? 'pointer' : 'initial')};

    @media (max-width: 768px) {
        font-size: 1.3rem;
    }

    // Small devices
    @media (max-width: 320px) {
        font-size: 1rem;
    }

    ::after {
        visibility: ${(props) => (props.isMaskEnabled ? 'visible' : 'hidden')};
        content: '';
        position: absolute;

        bottom: 0;
        left: 0;
        pointer-events: none;
        background-image: linear-gradient(
            to right,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 1) 70%
        );
        width: 100%;
        height: 2em;
    }
`;

export const BotaoVerTelefoneTexto = styled.label`
    cursor: pointer;
    text-decoration: underline;
    font-size: 1rem;
    color: #3f8eb5;
    text-transform: none;
`;
